export enum SocialPlatform {
	WHATSAPP,
	VIBER,
}
